import { ExchangeProperty } from "@/services";
import { IStatusProps } from "./components/Models";

export interface IDateTimeFormat {
  timeFormat: string;
  dateFormat: string;
}

export interface ITimelineProps {
  timeSlider: Date;
  startTimeSelected: Date;
  endTimeSelected: Date;
  events?: ITimeLineEvent[];
  buffer?: ITimelineBufferProps;
  isDisplayBufferTime?: boolean;
  localizer?: string;
  isNoInformation?: boolean;
  dateTimeFormat?: IDateTimeFormat;
  bufferTimeText?: string;
  minutesText?: string;
  closeTimeText?: string;
  exchangePropertyResource?: ExchangeProperty;
  isAttendee?: boolean;
}

export interface ITimelineBufferProps {
  preBufferTime?: number;
  postBufferTime?: number;
}

export interface WorkspaceInfo {
  capacity: number;
  available: boolean;
  currentAttendees: number;
  attendees: string[];
  noOfAttendees: number;
  remaining: number;
  transparent: string;
  maxOfLocationCapacity: number;
  isSelf: boolean;
  totalCapacity: number;
  isFakeTimeSlot: boolean;
}

export interface ITimeLineEvent {
  workspaceInfo?: WorkspaceInfo;
  id: string;
  start: Date;
  end: Date;
  bufferStatus: string;
  timelineStatus: string;
  preBufferTime?: number;
  postBufferTime?: number;
  organizerEmail?: string;
  subject?: string;
  timeZone?: string;
  isRecurring?: boolean;
  status?: string;
  isCurrentAppointment?: boolean;
}

export interface IStatusWrapperProps {
  _props: IStatusProps;
  evt: ITimeLineEvent;
  startIdx: number;
  endIdx: number;
  totalTile: number;
  children?: React.ReactElement;
}

export enum EventStatusEnum {
  Free = "free",
  Tentative = "tentative",
  WorkingElsewhere = "workingElsewhere",
  Closed = "closed",
  Busy = "busy",
  Selected = "selected",
  Away = "away",
}

export enum EventBufferEnum {
  BufferStart = "bufferStart",
  BufferEnd = "bufferEnd",
  Buffer = "buffer",
  NoneBuffer = "noneBuffer",
}
